import { ORDER_META_KEY, OrderType } from "../constants.js";
export const isCreditOrReturnOrder = (order) => {
    return order.meta?.some((meta) => meta.key === ORDER_META_KEY.ORDER.ORDER_TYPE &&
        (meta.value === OrderType.CREDIT || meta.value === OrderType.RETURN));
};
